import RecordList from "../components/RecordList";
function FuelPage() { return <RecordList title="Fuel entries" endpoint="/fuel" columns={[["date", "Date"], ["vehicleNo", "Vehicle"], ["driverName", "Driver"], ["fuelQuantity", "Litres"], ["ratePerLiter", "Rate / litre"], ["totalAmount", "Total"]]} />; }
export default FuelPage;
